import React from "react";
import withIconComponent from "../withIconComponent";

var Cart = function Cart() {
  return /*#__PURE__*/React.createElement("g", {
    className: "nc-icon-wrapper",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 4h18l-3 10H4",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 20a2 2 0 1 0 0 4 2 2 0 1 0 0-4zM20 20a2 2 0 1 0 0 4 2 2 0 1 0 0-4z",
    "data-color": "color-2",
    "data-stroke": "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1l3 3v10l-2 4h21",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    "data-cap": "butt"
  }));
};

export default withIconComponent("UiCart", false)(Cart);